<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog modal-lg" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onAdd(close)">
			<div class="modal-header py-2">
				<h1 class="modal-title fs-5">{{$t('header.question-add')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="text-center" v-if="loading">
					<loading-spinner
						:overlay="loading"
						:text="$t('text.loading-data')"
					></loading-spinner>
				</div>
				<div v-else>
					<div class="mb-3">
						<label for="input-question" class="form-label">{{$t('text.question')}}:</label>
						<textarea id="input-question" ref="question" rows="3" :placeholder="$t('placeholder.question-text')" class="form-control" v-model="question" required></textarea>
					</div>
					<div>
						<div>
							<label class="form-label">{{$t('text.question-img')}}:</label>
						</div>
						<input type="file" class="d-none" ref="question_img" @change="encodeImageFileAsURL($event, 'question_img')" />
						<img :src="question_img" class="mw-100 mb-2" v-if="question_img" />
						<div>
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="$refs['question_img'].click()" v-if="!question_img">{{$t('btn.select-question-img')}}</button>
							<button type="button" class="btn btn-sm btn-outline-danger" @click="question_img = ''" v-else>{{$t('btn.delete-question-img')}}</button>
						</div>
					</div>
					<div v-for="answer in answers" :key="answer.id">
						<hr/>
						<div class="mb-3">
							<div class="float-end">
								<div class="form-check">
									<label class="form-check-label">
										<span>{{$t('text.correct-answer')}} {{answer.id}}</span>
										<input class="form-check-input float-end ms-2" type="radio" :value="answer.id" v-model="correct_answer" />
									</label>
								</div>
							</div>
							<label :for="'input-answer'+answer.id" class="form-label">{{$t('text.answer-variant')}} {{answer.id}}:</label>
							<textarea :id="'input-answer'+answer.id" :ref="'answer'+answer.id" rows="3" :placeholder="$t('placeholder.answer-variant-text')+' '+answer.id" class="form-control" v-model="answer.text" required></textarea>
						</div>
						<div>
							<div>
								<label class="form-label">{{$t('text.answer-variant-img')}} {{answer.id}}:</label>
							</div>
							<input type="file" class="d-none" :ref="'answer'+answer.id+'_img'" @change="encodeImageFileAsURL($event, 'answer'+answer.id+'_img')" />
							<img :src="answer.img" class="mw-100 mb-2" v-if="answer.img" />
							<div>
								<button type="button" class="btn btn-sm btn-outline-secondary" @click="$refs['answer'+answer.id+'_img'][0].click()" v-if="!answer.img">{{$t('btn.select-answer-variant-img')}} {{answer.id}}</button>
								<button type="button" class="btn btn-sm btn-outline-danger" @click="answer.img = ''" v-else>{{$t('btn.delete-answer-variant-img')}} {{answer.id}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-primary" :disabled="loading">{{$t('btn.add')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import autosize from 'autosize';
import _ from 'lodash';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		question: '',
		question_img: '',
		
		answers: [
			{
				id: 1,
				text: '',
				img: '',
			},
			{
				id: 2,
				text: '',
				img: '',
			},
			{
				id: 3,
				text: '',
				img: '',
			},
			{
				id: 4,
				text: '',
				img: '',
			},
			{
				id: 5,
				text: '',
				img: '',
			},
		],
		
		correct_answer: 1,
		
		error: '',
		loading: false,
	}),
	methods: {
		encodeImageFileAsURL(e, ref){
			const files = e.target.files;
			if(files.length > 0){
				const reader = new FileReader();
				reader.onload = (e2) => {
					const srcData = e2.target.result; // <--- data: base64
					if(ref == 'question_img'){
						this.question_img = srcData;
					} else if(['answer1_img', 'answer2_img', 'answer3_img', 'answer4_img', 'answer5_img'].includes(ref)){
						this.answers.find(el => ref == 'answer'+el.id+'_img').img = srcData;
					}
					this.$refs[ref].value = null;
				}
				reader.readAsDataURL(files[0]);
			}
		},
		
		async onAdd(close){
			this.loading = true;
			this.error = '';
			
			const ret = await this.appModel.doAddQuestion(this.$vfm.modals[0].params._value.discipline_id, {
				text: this.question.trim(),
				img: this.question_img,
				answers: _.cloneDeep(this.answers).map(el => {
					el.text = el.text.trim();
					el.is_correct = el.id == this.correct_answer;
					delete el.id;
					return el;
				})
			});
			if(ret.success){
				this.$emit('add', close);
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
	},
	async mounted(){
		setTimeout(() => {
			autosize(this.$refs.question);
			autosize(this.$refs.answer1);
			autosize(this.$refs.answer2);
			autosize(this.$refs.answer3);
			autosize(this.$refs.answer4);
			autosize(this.$refs.answer5);
			
			this.$refs.question.focus();
		}, 300);
	},
	components: {
		LoadingSpinner,
	},
}
</script>